import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { IoClose } from 'react-icons/io5';

import { Text, Button } from 'modules/common';

import * as c from './constants';

function Banner({ label, type, withButton, buttonProps, withClose, onClose }) {
  const $type = c.dispatchType?.[type];
  const style = {
    background: $type?.background,
    icon: $type?.icon,
    buttonProps: $type?.buttonProps,
    text: $type?.text,
  };

  return (
    <div
      className={cn(
        'flex items-center gap-ds-12 p-ds-24',
        style?.background,
        withButton ? 'py-ds-12' : 'py-[21px]'
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        aria-hidden="true"
      >
        {c.dispatchIcon?.[type] || (
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4 8.00001C14.4 11.5346 11.5346 14.4 8.00001 14.4C4.46538 14.4 1.60001 11.5346 1.60001 8.00001C1.60001 4.46538 4.46538 1.60001 8.00001 1.60001C11.5346 1.60001 14.4 4.46538 14.4 8.00001ZM8.80001 4.80001C8.80001 5.24183 8.44183 5.60001 8.00001 5.60001C7.55818 5.60001 7.20001 5.24183 7.20001 4.80001C7.20001 4.35818 7.55818 4.00001 8.00001 4.00001C8.44183 4.00001 8.80001 4.35818 8.80001 4.80001ZM7.20001 7.20001C6.75818 7.20001 6.40001 7.55818 6.40001 8.00001C6.40001 8.44183 6.75818 8.80001 7.20001 8.80001V11.2C7.20001 11.6418 7.55818 12 8.00001 12H8.80001C9.24183 12 9.60001 11.6418 9.60001 11.2C9.60001 10.7582 9.24183 10.4 8.80001 10.4V8.00001C8.80001 7.55818 8.44183 7.20001 8.00001 7.20001H7.20001Z"
            fill="white"
          />
        )}
      </svg>

      <Text className={cn('flex-1', style?.text)} weight="semibold">
        {label}
      </Text>

      {withButton && (
        <Button label="Button" {...style?.buttonProps} {...buttonProps} />
      )}

      {withClose && (
        <button type="button" onClick={onClose}>
          <IoClose className={cn('h-4 w-4', style?.text)} />
        </button>
      )}
    </div>
  );
}

Banner.defaultProps = {
  buttonProps: {},
  withClose: true,
  type: 'default',
  withButton: false,
  label: '',
  onClose: () => {},
};

Banner.propTypes = {
  buttonProps: PropTypes.instanceOf(Object),
  withClose: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(c.dispatchType)),
  withButton: PropTypes.bool,
  onClose: PropTypes.instanceOf(Function),
};

export default Banner;
